export const getSaleFilter = state => state.saleReport.filter
